module.exports = __webpack_public_path__ + "static/media/DocsetTitle.ff6f037d.png";